export const COTACAO_FORM_ID = "cotacao-form";

export const COTACAO_TITLE = (codigo: string) => `Definir cotação: ${codigo}`;
export const COTACAO_ESCOPO_MESSAGE = "Esta cotação valerá para todos os escopos macro desta Obra.";
export const MOEDA_LABEL = "Moeda";
export const COTACAO_LABEL = "Cotação (R$)";
export const CANCELAR_LABEL = "Cancelar";
export const SALVAR_LABEL = "Salvar cotação";

export const COTACAO_OBRIGATORIA = "Informe a cotação.";
export const COTACAO_MAIOR_QUE_ZERO = "Informe uma cotação maior que zero.";
export const COTACAO_DEFINIDA_MESSAGE = (codigo: string) =>
  `Cotação de ${codigo} definida com sucesso.`;
